import { cx } from "@emotion/css";
import { KeyboardArrowDownRounded as DownIcon, KeyboardArrowUpRounded as UpIcon } from "@mui/icons-material";
import { Collapse as MuiCollapse } from "@mui/material";
import useOpenClose from "hooks/useOpenClose";
import TextButton from "library/Atoms/Button/TextButton";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import styles from "./styles";

const Collapse = ({ className, open, collapsedSize, color, children, ...restProps }) => {
  const { t } = useTranslation();

  const [isDetailsOpen, openDetails, closeDetails] = useOpenClose(false);

  return (
    <>
      <MuiCollapse
        classes={
          collapsedSize
            ? {
                root: styles.collapse(isDetailsOpen, color),
                wrapperInner: cx(className, "d-flex"),
              }
            : {}
        }
        in={collapsedSize ? isDetailsOpen : open}
        collapsedSize={collapsedSize}
        {...restProps}
      >
        {children}
      </MuiCollapse>

      {collapsedSize && (
        <div className={cx(styles.shadow, "d-flex justify-content-center my-2")}>
          <TextButton
            contentClassName="text-nowrap text-fs-12 text-fw-semibold"
            label={isDetailsOpen ? t("common.buttons.showLessBtn") : t("common.buttons.showMoreBtn")}
            onClick={isDetailsOpen ? closeDetails : openDetails}
            endIcon={isDetailsOpen ? <UpIcon className="pt-1" /> : <DownIcon className="pt-1" />}
            color="primary"
          />
        </div>
      )}
    </>
  );
};

Collapse.defaultProps = {
  className: null,
  open: false,
  color: "white",
  collapsedSize: null,
};

Collapse.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  color: PropTypes.oneOf(["white", "grey100"]),
  collapsedSize: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default Collapse;
